import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { DdCaseSearchResult } from '../../Common/Types/Search'
import { Highlight } from '@search-components'

const ResultCard = styled.div`
  padding: 1rem;
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: ${(props) => props.theme.box.borderRadius};
  background-color: ${(props) => props.theme.colors.primary};
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:hover {
    border-color: ${(props) => props.theme.colors.accentColor};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
`

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.375rem;
`

const CaseName = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.font.primary};
`

const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 0.375rem;
`

const StatusBadge = styled.span`
  font-size: 0.75rem;
  color: ${(props) => props.theme.colors.font.grey2};
  background-color: ${(props) => props.theme.colors.secondary};
  border-radius: 4px;
  padding: 0.1rem 0.4rem;
`

const MatchedInBadge = styled.span`
  font-size: 0.75rem;
  color: #1D4ED8;
  background-color: #DBEAFE;
  border-radius: 4px;
  padding: 0.1rem 0.4rem;
`

const AddressText = styled.span`
  font-size: 0.75rem;
  color: ${(props) => props.theme.colors.font.grey2};
`

const SnippetText = styled.p`
  font-size: 0.8125rem;
  color: ${(props) => props.theme.colors.font.tertiary};
  margin: 0;
  line-height: 1.5;
`

const matchedInLabel: Record<string, string> = {
  case: 'Caso',
  case_notes: 'Notas',
  case_messages: 'Mensajes',
}

interface DdCaseResultProps {
  result: DdCaseSearchResult
}

export const DdCaseResult = ({ result }: DdCaseResultProps) => {
  const navigate = useNavigate()

  return (
    <ResultCard onClick={() => navigate(`/due-diligence/case/${result.caseAlias}`)}>
      <CardHeader>
        <CaseName>{result.name}</CaseName>
      </CardHeader>
      <MetaRow>
        <StatusBadge>{result.status}</StatusBadge>
        <MatchedInBadge>{matchedInLabel[result.matchedIn] ?? result.matchedIn}</MatchedInBadge>
        {result.propertyAddress && (
          <AddressText>{result.propertyAddress}</AddressText>
        )}
      </MetaRow>
      <SnippetText>
        <Highlight html={result.snippet} />
      </SnippetText>
    </ResultCard>
  )
}
